/* AMBESA · MADE FOR CULTURE · interactions */
(function () {
  'use strict';
  var doc = document;
  var root = doc.documentElement;
  root.classList.add('amb-js', 'amb-ready');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  var revealIO = hasIO ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-in');
        revealIO.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 }) : null;

  function initReveal(scope) {
    var els = scope.querySelectorAll('[data-amb-reveal]:not(.is-in)');
    Array.prototype.forEach.call(els, function (el) {
      if (!revealIO || reduce) { el.classList.add('is-in'); return; }
      var parent = el.parentElement;
      var idx = parent ? Array.prototype.indexOf.call(parent.children, el) : 0;
      el.style.setProperty('--amb-delay', Math.min(idx, 6) * 70 + 'ms');
      revealIO.observe(el);
    });
  }

  var videoIO = hasIO ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var v = entry.target;
      if (entry.isIntersecting) {
        v.muted = true;
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      } else if (!v.paused) {
        v.pause();
      }
    });
  }, { threshold: 0.3 }) : null;

  function initVideos(scope) {
    var vids = scope.querySelectorAll('[data-amb-autoplay] video');
    Array.prototype.forEach.call(vids, function (v) {
      if (v.dataset.ambObserved) return;
      v.dataset.ambObserved = '1';
      v.muted = true;
      v.loop = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      v.removeAttribute('controls');
      /* muted reels play on every device, phones included, same as desktop */
      if (videoIO) videoIO.observe(v); else v.play();
    });
  }

  function initRails(scope) {
    var rails = scope.querySelectorAll('[data-amb-rail-root]');
    Array.prototype.forEach.call(rails, function (railRoot) {
      if (railRoot.dataset.ambReady) return;
      railRoot.dataset.ambReady = '1';
      var vp = railRoot.querySelector('[data-amb-rail]');
      if (!vp) return;
      var prev = railRoot.querySelector('[data-amb-prev]');
      var next = railRoot.querySelector('[data-amb-next]');
      var step = function () { return Math.max(vp.clientWidth * 0.8, 260); };
      var sync = function () {
        var max = vp.scrollWidth - vp.clientWidth - 2;
        if (prev) prev.disabled = vp.scrollLeft <= 2;
        if (next) next.disabled = vp.scrollLeft >= max;
      };
      if (prev) prev.addEventListener('click', function () { vp.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
      if (next) next.addEventListener('click', function () { vp.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
      vp.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }

  function initZoom(scope) {
    var zooms = scope.querySelectorAll('[data-amb-zoom]');
    Array.prototype.forEach.call(zooms, function (z) {
      if (z.dataset.ambReady) return;
      z.dataset.ambReady = '1';
      var lens = z.querySelector('.amb-zoom__lens');
      var src = z.getAttribute('data-zoom-src');
      var factor = parseFloat(z.getAttribute('data-zoom-factor') || '2.5');
      if (!lens || !src) return;
      var loaded = false;
      var raf = 0;
      var load = function () {
        if (loaded) return;
        loaded = true;
        lens.style.backgroundImage = 'url("' + src + '")';
      };
      var move = function (x, y) {
        var r = z.getBoundingClientRect();
        var px = Math.min(Math.max(x - r.left, 0), r.width);
        var py = Math.min(Math.max(y - r.top, 0), r.height);
        window.cancelAnimationFrame(raf);
        raf = window.requestAnimationFrame(function () {
          var lw = lens.offsetWidth;
          var lh = lens.offsetHeight;
          lens.style.transform = 'translate3d(' + px + 'px,' + py + 'px,0)';
          lens.style.backgroundSize = (r.width * factor) + 'px ' + (r.height * factor) + 'px';
          lens.style.backgroundPosition = (-(px * factor - lw / 2)) + 'px ' + (-(py * factor - lh / 2)) + 'px';
        });
      };
      var touch = window.matchMedia('(hover: none)').matches;
      z.addEventListener('pointerenter', function (e) {
        if (e.pointerType === 'mouse') { load(); z.classList.add('is-zooming'); move(e.clientX, e.clientY); }
      });
      z.addEventListener('pointermove', function (e) {
        if (e.pointerType === 'mouse' || z.classList.contains('is-zooming')) move(e.clientX, e.clientY);
      });
      z.addEventListener('pointerleave', function (e) {
        if (e.pointerType === 'mouse') z.classList.remove('is-zooming');
      });
      z.addEventListener('click', function (e) {
        if (!touch) return;
        load();
        z.classList.toggle('is-zooming');
        move(e.clientX, e.clientY);
      });
      z.addEventListener('touchmove', function (e) {
        if (!z.classList.contains('is-zooming')) return;
        e.preventDefault();
        var t = e.touches[0];
        move(t.clientX, t.clientY);
      }, { passive: false });
    });
  }

  function initSort(scope) {
    var sels = scope.querySelectorAll('[data-amb-sort]');
    Array.prototype.forEach.call(sels, function (sel) {
      if (sel.dataset.ambReady) return;
      sel.dataset.ambReady = '1';
      sel.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sel.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  }

  /* customs note: the country picked in the store's selector is handled in Liquid; here the visitor's
     detected country (one small request per visit) shows the note to people browsing from a listed country */
  var geo = null, geoWatch = false;
  function paintCustoms() {
    if (!geo) return;
    Array.prototype.forEach.call(doc.querySelectorAll('[data-amb-customs]:not(.is-on):not(.is-geo)'), function (n) {
      if ((n.getAttribute('data-countries') || '').split(',').indexOf(geo.code) < 0) return;
      n.classList.add('is-geo');
      var where = n.querySelector('[data-amb-customs-country]');
      if (where && !where.textContent && geo.name) where.textContent = geo.name;
    });
  }
  function useGeo(g) {
    geo = g;
    paintCustoms();
    /* the cart drawer re-renders its content: paint new notes as they arrive */
    if (!geoWatch && window.MutationObserver && /(^|,)(US|CA|NO|AU|CH|GB)(,|$)/.test(g.code)) {
      geoWatch = true;
      new MutationObserver(paintCustoms).observe(doc.body, { childList: true, subtree: true });
    }
  }
  function initCustoms() {
    if (geo) { paintCustoms(); return; }
    try {
      var cached = JSON.parse(window.sessionStorage.getItem('amb-geo') || 'null');
      if (cached && cached.code) { useGeo(cached); return; }
    } catch (e) {}
    if (!window.fetch || initCustoms.busy) return;
    initCustoms.busy = true;
    fetch('/browsing_context_suggestions.json?country%5Benabled%5D=true', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var c = d && d.detected_values && d.detected_values.country;
        if (!c || !c.handle) return;
        var g = { code: String(c.handle).toUpperCase(), name: String(c.name || '') };
        try { window.sessionStorage.setItem('amb-geo', JSON.stringify(g)); } catch (e) {}
        useGeo(g);
      })
      .catch(function () {});
  }

  function init(scope) {
    scope = scope || doc;
    initCustoms();
    initReveal(scope);
    initVideos(scope);
    initRails(scope);
    initZoom(scope);
    initSort(scope);
  }

  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', function () { init(doc); });
  } else {
    init(doc);
  }
  doc.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
